import React from 'react';
import { ORDER_STATUS_LABELS } from '../../constants';
import { formatPrice } from '../../utils';
import './CustomerCard.css';

const CustomerCard = ({ 
  customer, 
  onEdit, 
  onCopy,
  onDelete, 
  isLoading, 
  formatDate,
  remainingAmount,
  permissions = {} // Rol bazlı yetkiler
}) => {
  return (
    <div className="customer-card">
      <div className="card-header">
        <div className="customer-name">
          <h4>{customer.name}</h4>
        </div>
        <span className={`status-badge status-${customer.orderStatus || 'new_order'}`}>
          {ORDER_STATUS_LABELS[customer.orderStatus || 'new_order']}
        </span>
      </div>
      
      <div className="card-content">
        <div className="card-info">
          <div className="info-item">
            <i className="fas fa-phone"></i>
            <span>{customer.phone1}</span>
          </div>
          
          {customer.phone2 && (
            <div className="info-item">
              <i className="fas fa-phone"></i>
              <span>{customer.phone2}</span>
            </div>
          )}
          
          {customer.email && (
            <div className="info-item">
              <i className="fas fa-envelope"></i>
              <span>{customer.email}</span>
            </div>
          )}
          
          {customer.tcNo && (
            <div className="info-item tc-no">
              <i className="fas fa-id-card"></i>
              <span>TC/Vergi No: {customer.tcNo}</span>
            </div>
          )}
          
          <div className="info-item">
            <i className="fas fa-calendar"></i>
            <span>Sipariş: {formatDate(customer.orderDate)}</span>
          </div>
          
          <div className="info-item">
            <i className="fas fa-calendar-check"></i>
            <span>Teslimat: {formatDate(customer.deliveryDate)}</span>
          </div>
          
          {customer.address && (
            <div className="info-item address">
              <i className="fas fa-map-marker-alt"></i>
              <span>{customer.address}</span>
            </div>
          )}
          
          {customer.notes && (
            <div className="info-item notes">
              <i className="fas fa-sticky-note"></i>
              <span>{customer.notes}</span>
            </div>
          )}

          <div className="info-item remaining-payment">
            <i className="fas fa-money-bill-wave"></i>
            <span>
              Kalan Ödeme: {
                remainingAmount !== undefined ? (
                  remainingAmount === -1 ? (
                    <span className="no-order">
                      <i className="fas fa-minus-circle"></i> Sipariş Yok
                    </span>
                  ) : (customer.isPaymentCompleted || remainingAmount === 0) ? (
                    <span className="payment-completed">
                      <i className="fas fa-check-circle"></i> Ödeme Alındı
                    </span>
                  ) : (
                    <span className="remaining-amount">{formatPrice(remainingAmount)} ₺</span>
                  )
                ) : (
                  <span className="loading-amount">...</span>
                )
              }
            </span>
          </div>
        </div>
      </div>
      
      <div className="card-actions">
        {/* Düzenleme butonu - Montajcı da görür (durum güncelleme için) */}
        <button 
          onClick={() => onEdit(customer)}
          className="edit-btn"
          disabled={isLoading}
          title={permissions?.canEditCustomer ? "Düzenle" : "Detaylar"}
        >
          <i className={`fas ${permissions?.canEditCustomer ? 'fa-edit' : 'fa-eye'}`}></i>
        </button>
        
        {/* Kopyalama butonu - Montajcı göremez */}
        {permissions?.canCreateCustomer && (
          <button 
            onClick={() => onCopy(customer)}
            className="copy-btn"
            disabled={isLoading}
            title="Müşteriyi Kopyala"
          >
            <i className="fas fa-copy"></i>
          </button>
        )}
        
        {/* Silme butonu - Montajcı göremez */}
        {permissions?.canDeleteCustomer && (
          <button 
            onClick={() => onDelete(customer)}
            className="delete-btn"
            disabled={isLoading}
            title="Sil"
          >
            <i className="fas fa-trash"></i>
          </button>
        )}
      </div>
    </div>
  );
};

export default CustomerCard; 